import { toast } from "sonner";
import request from "../../../helpers/request";

export type TRequestRptPtosPanorama = {
  idAlerta: string, 
  typeReport: string
}

export const getRptAlertaLista = async ({
  dataIni,
  dataFim,
  idDivisao,
  idRegional,
  idLoja,
  idGrupoMonitor,
  idEquipamento,
  manutencao,
  reportType
}) => {
  if (typeof reportType === "undefined" || !reportType) {
    return toast.error("Selecione um formato para baixar os relatórios.");
  }
  const _dataIni = dataIni ? `&dataIni=${dataIni}` : ""
  const _dataFim = dataFim ? `&dataFim=${dataFim}` : ""
  const _idDivisao = idDivisao ? `&idDivisao=${idDivisao}` : ""
  const _idRegional =  idRegional ? `&idRegional=${idRegional}` : ""
  const _idLoja =  idLoja ? `&idLoja=${idLoja}` : ""
  const _idGrupoMonitor =  idGrupoMonitor ? `&idGrupoMonitor=${idGrupoMonitor}` : ""
  const _idEquipamento = idEquipamento ? `&idEquipamento=${idEquipamento}` : ""
  const _manutencao =  manutencao ? `&manutencao=${manutencao}` : ""
  const _reportType =  reportType ? `&reportType=${reportType}` : ""
  const str = `${_dataIni}${_dataFim}${_idDivisao}${_idRegional}${_idLoja}${_idGrupoMonitor}${_idEquipamento}${_manutencao}${_reportType}`
  
  const url = `${process.env.REACT_APP_API}/Relatorio/RptAlertaLista?${str}`;
  const result = await request({ url, responseType: "blob" });
  return result;
};
